import React, { useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import Chip from "@material-ui/core/Chip";
import Course from "./course";
import { getFilteredCourses, getAllFilters } from "./util";
import List from "@material-ui/core/List";
import { AppContext, SET_COURSEFILTER } from "../Context";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  courseList: {
    width: "1024px",
    margin: "16px auto",
    "@media(max-width: 1300px)": {
      width: "77%",
    },
    "@media(max-width: 1024px)": {
      width: "100%",
      margin: 0,
    },
  },
  heading: {
    margin: "4px 0",
    "@media(max-width: 667px)": {
      fontSize: "1.3rem",
    },
  },
  list: { padding: 0 },
  filterContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "0.5rem",
    marginTop: "1rem",
    marginBottom: "1rem",
  },
  chip: {
    margin: "4px",
    "& svg": {
      color: theme.app.badge.color,
    },
  },
}));

const CoursesList = (props) => {
  const { manages, courses } = props;
  const classes = useStyles();
  const context = useContext(AppContext);
  const { state, dispatch } = context;
  const { courseFilter } = state;
  const { language } = useSelector((state) => ({
    language: state.language
  }));
  const filteredCourses = getFilteredCourses(courses, courseFilter);
  const filterChips = getAllFilters(courseFilter);
  const removeCourseFilter = (type, value, checked) =>
    dispatch({ type: SET_COURSEFILTER, payload: { type, value, checked } });
  return (
    <div className={classes.courseList}>
      <div className={classes.filterContainer}>
        {filterChips.map((f, i) => {
          return (
            <>
              <Chip
                className={classes.chip}
                key={i}
                label={f.label}
                onClick={() => removeCourseFilter(f.type, f.value, false)}
                onDelete={() => removeCourseFilter(f.type, f.value, false)}
                color="primary"
                aria-label={`${language.removeFilter} ${f.label}`}
              />
            </>
          );
        })}
      </div>
      <div className={classes.courseGroupContainer}>
        {filteredCourses.map((g, i) => (
          <div key={i}>
            <List className={classes.list}>
              {g.courses.map((course, i) => {
                return (
                  <Course
                    key={course.id}
                    course={course}
                    showTooltip={true}
                    manages={manages}
                    index={i}
                  />
                );
              })}
            </List>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CoursesList;
